import { type BidStateFilter } from './RfpSummary'

export const RFP_HISTORY_PAGE_SIZE = 20

export type RfpHistoryMetadata = Record<BidStateFilter, number>

export type RfpHistoryParams = {
  bidState: BidStateFilter
  page: number
}

export const initialRfpHistoryParams: RfpHistoryParams = { bidState: 'all', page: 1 }
